export default "__VITE_ASSET__CvXiW3sE__"